export default __webpack_public_path__ + "static/media/chemist.19f202cd.mp3";